export default {
    membership_management: {
        no_membership_number: 'Completate il vostro primo investimento per diventare membri.',
        membership_number: 'Numero di iscrizione',
        download_document: 'Scarica il documento di adesione',
        send_document: 'Ricevere il modulo per posta',
        send_document_requested: 'Richiesta di invio del documento',
        send_document_sent: 'Il documento è stato inviato',
        document_label: 'Documento di adesione',
        // prettier-ignore
        order_certificates: 'Certificato d\'investimento',
    },
    account_dropdown_log_out: 'Disconnettersi',
    account_dropdown_company_account: 'Conto aziendale',
    // prettier-ignore
    account_dropdown_tooltip_account: 'Conto dell\'investitore',
    // prettier-ignore
    account_dropdown_tooltip_fill_account_data: 'Compilare i dati dell\'investitore',
    account_dropdown_tooltip_orders: 'investimento',
    account_dropdown_tooltip_wallets: 'Portafoglio',
    personal_account: 'Panoramica del conto',
    welcome: 'Benvenuti nel vostro conto',
    header_new_investor: 'Nuovo investitore?',
    header_register: 'Registrarsi',
    header_sign_in: 'Effettuare il login',
    header_unfinished_investment_process: 'Hai un investimento in corso',
    header_sign_in_new: 'Accedi',
    header_register_new: 'Registrati',
    header_new_to_invest_new: 'Nuovo investitore?',
    header_modal_body_new:
        'Se è la prima volta che investi, registrati. Hai già investito su CONDA Capital Market o CONDA Crowdinvesting? Puoi accedere con le tue credenziali di accesso attuali.',
    header_modal_title_new: 'Per investire hai bisogno di un account utente',
    // prettier-ignore
    email_verification_already_verified: 'L\'indirizzo e-mail è già stato verificato',
    // prettier-ignore
    email_verification_email_pending_missmatch:
        'Non è stato possibile verificare l\'indirizzo e-mail. Nel frattempo è stata avviata un\'altra verifica dell\'e-mail. Si prega di riprovare.',
    email_verification_expired_link: 'Il link di verifica è scaduto.',
    email_verification_verified: 'Il vostro indirizzo e-mail è stato modificato!',
    create_company_profile_question: 'Volete aprire un conto aziendale per il vostro conto?',
    create_company_profile: 'Creare un conto aziendale',
    language_switcher_select_language: 'Selezionare la lingua',
    discard: 'Annullamento',
    header: {
        sign_in: 'Entrare',
        register: 'Registra un conto',
        new_to_invest: 'Registra un conto',
    },
    kyc_provider: {
        idnow: 'IDNow',
        signteq: 'Signteq',
    },
    pay_via_eth: 'Pagare tramite ETH',
    gas_limit: 'Prezzo del gas',
    address_to_send_eth: 'Indirizzo di ricezione per ETH',
    pay_via_eth_desc:
        // prettier-ignore
        'Pagamento tramite ETH Descrizione: Se si utilizza il bonifico bancario come opzione per il pagamento, è prevista una commissione aggiuntiva basata sull\'importo totale dell\'investimento. Commissione aggiuntiva per il trasferimento dell\'investimento.',
    portfolio_size: 'Dimensione del portafoglio',
    view_details: 'Mostra dettagli',
    date: 'Data',
    time: 'Ora',
    total: 'Importo totale',
    // prettier-ignore
    investment: 'Importo dell\'investimento',
    // prettier-ignore
    investment_amount: 'Importo dell\'investimento',
    support_amount: 'Importo del sostegno',
    order_status_canceled: 'Annullato',
    order_status_pending: 'In sospeso',
    order_status_paid: 'Pagato',
    order_status_approved: 'Confermato',
    order_status_covered: 'Coperto',
    order_status_accepted: 'Accettato',
    my_orders_side: 'I miei investimenti',
    no_order: 'Nessun investimento',
    order_voucher_amount: 'Importo del buono',
    order_discount_voucher_amount: 'Importo del codice voucher',
    order_wallet_amount: 'Importo dal portafoglio',
    success: '',
    error: '',
    copy: '',
    save: 'Salva',
    cancel: 'Annulla',
    copy_to_clipboard: '',
    copied_to_clipboard: '',
    errors: {
        validation_error: '',
        general_error: '',
        // prettier-ignore
        kyc_id_required: 'Il KYC è richiesto per procedere con l\'investimento',
        // prettier-ignore
        bank_account_required: 'È necessario un conto bancario per procedere con l\'investimento',
        // prettier-ignore
        kyc_address_required: 'La verifica dell\'indirizzo è necessaria per procedere con l\'investimento',
        // prettier-ignore
        kyc_tax_required: 'La verifica fiscale è necessaria per procedere con l\'investimento',
    },
    terms_link: '',
    privacy_link: '',
    admin_email: '',
    contact_support: '',
    investment_process: {
        close: 'Chiudere',
        cancel: 'Annullare',
        pay_now: 'Pagare ora',
        accept_savings_plan: 'Piano di risparmio',
        payment_processing:
            'Il pagamento è in fase di elaborazione. Segui le istruzioni nella finestra del fornitore del servizio di pagamento. Non chiudere questa pagina.',
        payment_successful: 'Pagamento effettuato con successo.',
        payment_failed: 'Pagamento non riuscito. ',
        try_again: 'Riprova',
        prepaid_payment_successful:
            'Il tuo pagamento è in fase di elaborazione. Lo stato del tuo investimento verrà aggiornato una volta che il pagamento sarà stato ricevuto con successo.',
        // prettier-ignore
        accept_gift_membership: 'Regalo d\'iscrizione',
        visit_faq_url: 'Per maggiori informazioni clicca qui',
        emission_agio_text: '',
        emission_disagio_text: '',
        sign_digitally: '',
        show_document: 'Mostra documento',
        signature: 'Abbonarsi',
        // prettier-ignore
        confirm_signature: 'Finalizzare l\'abbonamento',
        reset_verification_header: 'Dobbiamo reimpostare la tua verifica',
        // prettier-ignore
        reset_verification_body:
            'Poiché sei ancora verificato tramite il nostro precedente partner IDnow, è necessaria una nuova verifica tramite Signteq prima di poter investire.<br><br>' +
            // prettier-ignore
            'Contattateci via email all\'indirizzo <a href="mailto:support{\'@\'}conda-capital.com">support{\'@\'}conda-capital.com</a>, per reimpostare il processo di verifica.',
        signature_legal_notice: '',
        modal_reset_verification_header: '',
        modal_reset_verification_body: '',
        modal_reset_verification_button: '',
        signature_legal_notice_title: '',
        nyala_vault: '',
        or: '',
        download_signature_document: '',
        signature_document: 'Documento di firma',
        law_requirements: '',
        summary: '',
        payment: '',
        contract_period: '',
        issuer: 'Emittente',
        minimum_investment: '',
        steps: '',
        next: '',
        back: '',
        time_left: '',
        to_the_landing_page: '',
        thank_you_for_you_investment: '',
        pay_via_bank_transfer_header: '',
        pay_via_bank_transfer_description: '',
        go_to_my_orders: '',
        please_accept_all_documents: '',
        please_accept_all_disclaimers: '',
        please_accept_all_warnings: '',
        wallet_retrievable_balance: 'Importo disponibile sul portafoglio',
        voucher_available_balance: 'Importo disponibile sul voucher',
        update_wallet_amount: 'Regola il saldo del portafoglio',
        apply_wallet_amount: 'Attivare il saldo del portafoglio',
        update_voucher_amount: 'Regolare il saldo del voucher',
        apply_voucher_amount: 'Attivare il saldo del buono',
        discount_code_applied_successfully: 'Il codice del buono è stato attivato con successo',
        discount_code_higher_than_amount:
            // prettier-ignore
            'Il codice del buono non può essere applicato perché lo sconto è superiore all\'importo residuo',
        available: 'disponibile',
        discount_code: 'Codice del buono',
        apply_discount_button: 'Attivare',
        activate_balance: '',
        public_name_consent: '',
        disclaimers: '',
        understand_all_risks: '',
        contract_documents: '',
        accept_all_documents: '',
        accept_all_warnings: '',
        investment_warnings: '',
        investment_warnings_description: '',
        pre_contractual_cooling_off_period: '',
        pre_contractual_cooling_off_period_description: '',
        incentives: '',
        incentive: '',
        selected_incentive: '',
        select_incentive: '',
        which_contract_type: '',
        voucher_title: '',
        voucher_description: '',
        cash_title: '',
        cash_description: '',
        enter_investment_amount: '',
        min_amount: '',
        max_amount: '',
        step_level: '',
        invest: '',
        depot_additional_fields: 'Informazioni sul suo conto titoli',
        depot_owner: 'Intestatario del conto',
        depot_number: 'Numero di conto',
        depot_bank: 'Nome della banca',
        depot_bic: 'BIC o codice bancario',
        enter_investment_pieces: '',
        emission_pieces_to_amount: '',
        emission_amount_to_pieces: '',
        investment_summary: '',
        investment_amount: '',
        wallet_amount: 'Saldo del portafoglio',
        wallet_amount_description:
            // prettier-ignore
            'Selezionare l\'importo che si desidera coprire con il saldo del portafoglio esistente.',
        voucher_amount: '',
        voucher_amount_description:
            // prettier-ignore
            'Selezionare il buono desiderato e l\'importo che si desidera attivare.',
        expires_at: 'Scade il',
        contract_type: '',
        amount_to_pay: '',
        registration_number: '',
        address: '',
        invest_as_natural_profile: '',
        invest_as_legal_profile: '',
        invest_in: '',
        create_order: '',
        payment_account_holder_default: '',
        pay_via_credit_card_header: '',
        pay_via_credit_card_description: '',
        pay_via_credit_card_button: '',
        verification_outstanding: '',
        verification_outstanding_description: '',
        verify_button: 'Verifica ora',
        broker: '',
        broker_id: '',
        please_provide_broker_id: '',
        please_confirm: '',
        please_confirm_your_details: '',
        please_fill_required_fields: '',
        note: 'Nota',
        ecsp: {
            not_enough_experience_title: '',
            not_enough_experience_description: '',
            not_enough_risk_acknowledgements_title: '',
            not_enough_risk_acknowledgements_description: '',
            investment_too_high_title: '',
            investment_too_high_description: '',
        },
        altfg: {
            investment_process_altfg_notice: '',
            investment_process_altfg_choice_notice: '',
            investment_process_altfg_professional_investor: '',
            investment_process_altfg_legal_entity: '',
            investment_process_altfg_maximum_net_income: '',
            investment_process_altfg_maximum_assets: '',
        },
        vermanlg: {
            personal_data_verification_note:
                'Assicurati che i dati inseriti corrispondano esattamente, lettera per lettera (inclusi punto e virgola), ai tuoi dati personali. In caso contrario, apparirà il messaggio di errore «Dati incompleti». In tal caso, verifica nuovamente la corrispondenza.',
            vib_investor_from_germany: '',
            investments_information_sheet: '',
            vib_current_location: '',
            vib_date: '',
            vib_email: '',
            vib_first_name: '',
            vib_last_name: '',
            vib_place_of_birth: '',
            vib_date_of_birth: '',
            vib_id_card_passport_number: '',
            issuing_authority: '',
            vib_address: '',
            vib_postal_code: '',
            vib_city: '',
            vib_state: '',
            vib_tax_number: '',
            vib_investment_information: '',
            vib_investment_under_1000: '',
            vib_investment_financial_assets_over_10000: '',
            vib_investment_income_over_1k: '',
            vib_investment_income_over_10k: '',
            vib_investment_limit_part_1: '',
            vib_investment_limit_part_2: '',
            vermanlg_confirm_section_note:
                'Si prega di utilizzare gli stessi dati del proprio profilo di investitore! Tutti i campi sono obbligatori.',
            vermanlg_right_of_withdrawal: '',
            vermanlg_right_of_withdrawal_disclaimer: '',
            vermanlg_consequences_of_revocation: '',
            vermanlg_consequences_of_revocation_disclaimer: '',
        },
        // prettier-ignore
        stock_price: 'Prezzo dell\'azione',
        agio: 'Aggio',
        disagio: 'Disaggio',
        per_share: 'per azione',
        pre_emptive_rights_notice_title: 'Diritti di prelazione richiesti',
        pre_emptive_rights_notice_body:
            'Un investimento in questa campagna richiede diritti di prelazione. Al momento possiedi:',
        pre_emptive_rights_units: 'diritto/i',
    },
    forms: {
        select_option: '',
        radio_no: '',
        radio_yes: '',
        radio_male: '',
        radio_female: '',
        day: '',
        month: '',
        year: '',
        dd: '',
        mm: '',
        yyyy: '',
    },
    account: {
        investor_account: '',
        my_profile: '',
        first_name: '',
        last_name: '',
        save: '',
        date_of_birth: '',
        nationality: '',
        address: '',
        postal_code: '',
        city: '',
        same_as_residential: '',
        country_of_birth: '',
        city_of_birth: '',
        // prettier-ignore
        esac_locked_account_info:
            'Per modificare o aggiornare il proprio profilo o le informazioni e i documenti KYC, contattare il team ESAC via e-mail all\'indirizzo platform{\'@\'}superangels.club.',
        phone_number: '',
        iban: '',
        bic: '',
        social_security_number: '',
        tax_number: '',
        mobile_number: '',
        current_email: '',
        email_pending: '',
        new_email: '',
        email_address: '',
        country: '',
        state: '',
        gender: '',
        gender_placeholder: '',
        pep: '',
        pep_past: '',
        pep_position: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        saved_kyc_successfully_message: '',
        average_investment_transaction_amount: '',
        average_investment_transactions_per_year: '',
        investment_transactions: '',

        experience_share: '',
        experience_bond: '',
        experience_participation_paper: '',
        experience_crypto_currency: '',
        experience_unsecured_junior_debt: '',
        knowledge_share: '',
        knowledge_bond: '',
        knowledge_participation_paper: '',
        knowledge_crypto_currency: '',
        knowledge_unsecured_junior_debt: '',

        experience_with_securities: '',
        experience_without_advice: '',
        experience_with_asset_management: '',
        experience_with_investment_advice: '',

        bonds: '',
        stocks: '',
        market_funds: '',
        investment_funds: '',
        experience_investment_forms: '',
        current_occupation: '',
        highest_educational_attainment: '',
        default_language: 'Lingua predefinita',
    },
    portfolio: {
        investments_total: '',
        open_investments: '',
        my_investments: '',
        secondary_market_pre_emptive_rights_title: 'Mercato secondario - I miei diritti di opzione',
        rights_unit: 'Diritti di opzione',
        unit_short: 'pz.',
        no_investments_to_show: '',
        orders: {
            order_status: '',
            order_status_active: '',
            order_status_completed: '',
            order_status_canceled: '',
            order_status_pending: '',
            order_status_paid: '',
            order_status_approved: '',
            order_status_covered: '',
            order_status_accepted: '',
        },
    },
    investment_targets: {
        investment_objectives: 'Obiettivi di investimento',
        // prettier-ignore
        legal_investment_objectives: 'Obiettivi di investimento della società',
        security_coverage: 'Piano pensionistico',
        // prettier-ignore
        security_coverage_or_pension_plan: 'Copertura di sicurezza dell\'indennità o del piano pensionistico',
        pension_provision: 'Accantonamento per la pensione',
        retention_of_assets: 'Mantenimento del patrimonio',
        distribution_of_assets: 'Distribuzione del patrimonio',
        capital_gain: 'Guadagno in conto capitale',
        investment_horizon: 'Il vostro orizzonte di investimento',
        // prettier-ignore
        legal_investment_horizon: 'Orizzonte di investimento della società',
        investment_frequency:
            'Frequenza dei vostri investimenti in attività alternative (compresi venture capital e private equity)',
        // prettier-ignore
        legal_investment_frequency:
            'Frequenza degli investimenti dell\'azienda in attività alternative (inclusi venture capital e private equity):',
    },
    financial_conditions: {
        financial_assets: 'Attività finanziarie (in EUR)',
        // prettier-ignore
        annual_operating_result: 'Utile netto dell\'anno (in EUR)',
        dept_capital: 'Capitale di terzi (in EUR)',
        properties: 'Proprietà di beni immobili',
        // prettier-ignore
        source_of_funds:
            'Fonte di finanziamento (è l\'origine del finanziamento specifico che si intende investire)',
        dividends_or_profits: 'Dividendi o profitti da investimenti',
        // prettier-ignore
        lottery_gambling: 'Lotteria/gioco d\'azzardo',
        divorce: 'Divorzio',
        maturity_or_surrender: 'Scadenza o riscatto di una polizza di assicurazione sulla vita',
        gift: 'Dono',
        inheritance: 'Diritto di eredità',
        insurance_claims: 'Prestazioni assicurative',
        sale_of_property: 'Vendita di beni immobili',
        savings: 'Conti di risparmio',
        loan: 'Prestito',
        other: 'Altri servizi',
        industry: 'Settore della vostra attività principale e/o della vostra attività:',
        // prettier-ignore
        business_industry: 'Settore dell\'attività principale dell\'azienda:',
        dividends_or_profits_legal: 'Dividendi o profitti derivanti da partecipazioni/investimenti/attività',
        retained_earnings: 'Utili detenuti',
    },
    fatca_declaration: {
        cannot_continue: 'Purtroppo non è possibile completare il processo KYC online.',
        // prettier-ignore
        financial_institutions_under_fatca:
            'Classificazione FATCA della società: La società è un\'istituzione finanziaria (FI) ai sensi del FATCA?',
        // prettier-ignore
        contact_support: 'Si prega di contattare Venionaire alla support{\'@\'}superangels.club.',
        us_citizen_or_resident: 'Siete cittadini statunitensi e/o residenti negli Stati Uniti a fini fiscali?',
        // prettier-ignore
        non_financial_entity_reason:
            'Selezionare una delle seguenti categorie per quanto riguarda il tipo di entità non finanziaria dell\'investitore (forma giuridica)',
        financial_institution_category:
            'Istituzioni finanziarie ai sensi del FATCA: selezionare una delle seguenti categorie:',
        // prettier-ignore
        us_entity: 'L\'entità è un soggetto statunitense ai sensi della normativa FATCA?',
        provide_giin: 'Potete fornire il GIIN del titolare registrato ai fini FATCA?',
        // prettier-ignore
        no_giin_reason:
            'Se la società è un\'istituzione finanziaria ma non può rilasciare un GIIN, selezionare una delle seguenti motivazioni:',
        giin: 'Si prega di fornire il GIIN della società ai fini FATCA:',
        giin_sponsor_name: 'Nome dello sponsor',
        giin_sponsor: 'GIIN dello sponsor',
    },
    crs_classification: {
        company_classification: 'Classificazione CRS della società:',
        stock_exchange_name: 'Indicare il nome della borsa in cui le azioni della società sono regolarmente negoziate:',
        affiliate_stock_exchange_name:
            'O se avete una società correlata di una società che è regolarmente negoziata su una borsa stabilita, si prega di fornire il nome della borsa stabilita e della società:',
    },
    country_tax_residencies: {
        // prettier-ignore
        add_another_tax_residence: 'Aggiungere un\'altra residenza fiscale',
        cant_obtain_tin: 'Non posso ottenere un TIN',
        tax_situation: 'La vostra situazione fiscale',
        tax_residency: 'Residenza fiscale',
        // prettier-ignore
        capital_gains: 'Esenzione dall\'imposta sulle plusvalenze (KESt)',
        // prettier-ignore
        foreign_assets_ownership: 'Possesso di beni all\'estero',
        foreign_assets: 'Patrimonio estero',
        // prettier-ignore
        capital_gains_legal: 'Esenzione dall\'imposta sulle plusvalenze (KESt)',
        // prettier-ignore
        corporate_tax_exemption: 'Esenzione dall\'imposta sulle società (KÖSt)',
        group_taxation: 'Tassazione di gruppo',
    },
    legal_acknowledgements: {
        // prettier-ignore
        risks_acknowledgement:
            'Dichiaro/iamo che Venionaire Ventures S.à r.l. ("VV") non accetterà alcuna richiesta di acquisto di quote del fondo in assenza di informazioni sulla propensione al rischio. Inoltre, dichiariamo che, oltre ai rischi elencati, possono verificarsi fluttuazioni di valore dovute a fluttuazioni valutarie (compresa l\'inflazione).',
        // prettier-ignore
        anti_money_laundering:
            'In conformità alla legge modificata contro il riciclaggio di denaro e il finanziamento del terrorismo del 12 novembre 2004, dichiaro/iamo che i titolari effettivi comunicati (UBO) sono i titolari effettivi finali dell\'investitore e mi impegno a informare il revisore di VV di qualsiasi modifica della struttura azionaria, dei diritti di voto o dei titolari effettivi dell\'investitore. Dichiaro/dichiariamo inoltre che l\'origine dei fondi e dei titoli utilizzati per le attività commerciali dell\'investitore non viola la legge sopra citata. Infine, dichiaro/dichiariamo che l\'uso previsto del patrimonio derivante da queste transazioni non violerà tale legge.',
        // prettier-ignore
        authorised_signatory:
            'Confermo di essere il/i firmatario/i autorizzato/i dell\'investitore e dichiaro che è obbligatorio, ai sensi dell\'articolo 5 della legge lussemburghese sui CRS, rispondere alle domande relative alle informazioni comunicate nell\'autocertificazione fiscale.',
        // prettier-ignore
        tax_authorities:
            'In particolare, dichiariamo e accettiamo che le Informazioni divulgate possano essere comunicate alle autorità fiscali lussemburghesi o ad altri rappresentanti autorizzati ai sensi della legge lussemburghese in conformità alle informazioni richieste per i conti finanziari (cfr. Allegato I, Sezione I della legge "Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", di seguito "Legge CRS del Lussemburgo") in relazione all\'Investitore o ai suoi proprietari sostanziali finali e a qualsiasi registro comunicabile. Inoltre, dichiariamo e accettiamo che le informazioni divulgate possano essere scambiate con le autorità fiscali dei paesi in cui noi e/o l\'investitore abbiamo la residenza fiscale, in conformità agli accordi intergovernativi sullo scambio di dati fiscali.',
        intergovernmental_tax_exchange:
            'Autorizzo/iamo VV a condividere/scambiare tutte le informazioni divulgate, nonché le informazioni richieste per la rendicontazione ai sensi degli accordi intergovernativi per lo scambio di dati fiscali come sopra descritto, con le autorità fiscali competenti dei paesi o delle giurisdizioni.',
        // prettier-ignore
        notify_about_changes:
            'Accetto/accettiamo di notificare a VV entro 30 giorni qualsiasi cambiamento che influisca sull\'autocertificazione e sulle informazioni fornite, e di fornire a VV una corrispondente autocertificazione aggiornata senza indugio e senza richiesta. Su richiesta, ho/abbiamo accesso ai dati che mi/ci riguardano, che saranno condivisi con le autorità fiscali lussemburghesi, e posso/possiamo correggere i dati personali. I dati raccolti non saranno conservati più a lungo di quanto necessario ai fini della legge lussemburghese sui CRS.',
        information_correct_and_complete:
            'Dichiaro/iamo che tutte le informazioni da me/noi fornite sono corrette e complete al meglio delle mie conoscenze e convinzioni.',
    },
    acknowledgements: {
        check_all: 'Selezionare tutti',
        // prettier-ignore
        currency_change_risk:
            'Dichiaro/dichiariamo che Venionaire Ventures S.à r.l. ("VV") non accetterà alcuna richiesta di acquisto di quote del fondo in assenza di informazioni sulla propensione al rischio. Dichiariamo inoltre che, oltre ai rischi elencati, possono verificarsi fluttuazioni di valore dovute a variazioni valutarie (compresa l\'inflazione).',
        // prettier-ignore
        own_account:
            'Il/la sottoscritto/a conferma di essere il/i firmatario/i autorizzato/i dell\'investitore e dichiara di essere obbligato/a, ai sensi dell\'articolo 5 della legge lussemburghese sui CRS, a rispondere alle domande relative alle informazioni fornite nell\'autocertificazione fiscale.',
        // prettier-ignore
        anti_money_laundering:
            'In conformità alla legge modificata sulla lotta contro il riciclaggio di denaro e il finanziamento del terrorismo del 12 novembre 2004, dichiaro/iamo che i beneficiari effettivi comunicati (UBO) sono i beneficiari effettivi finali dell\'investitore e mi impegno a informare il revisore dei conti di VV di qualsiasi modifica della struttura azionaria, dei diritti di voto o dei beneficiari effettivi dell\'investitore. Dichiaro/dichiariamo inoltre che l\'origine dei fondi e dei titoli utilizzati per le attività commerciali dell\'investitore non viola la legge sopra citata. Infine, dichiaro/dichiariamo che anche l\'uso previsto del patrimonio derivante da queste transazioni non violerà tale legge.',
        self_certification_form:
            'In particolare, dichiariamo e accettiamo che le informazioni divulgate possano essere comunicate alle autorità fiscali lussemburghesi o ad altri rappresentanti autorizzati ai sensi della legge lussemburghese in conformità alle informazioni richieste per i conti finanziari (cfr. Allegato I, Sezione I della legge "Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", di seguito "Legge CRS del Lussemburgo") in relazione all\'investitore o ai suoi proprietari sostanziali finali e a qualsiasi registro da segnalare. Inoltre, dichiariamo e accettiamo che le informazioni divulgate possano essere scambiate con le autorità fiscali dei paesi in cui noi e/o l\'investitore abbiamo la residenza fiscale, in conformità agli accordi intergovernativi sullo scambio di dati fiscali.',
        tax_data_exchange_agreement:
            'Autorizzo/iamo VV a condividere/scambiare tutte le informazioni divulgate, nonché le informazioni richieste per la rendicontazione ai sensi degli accordi intergovernativi per lo scambio di dati fiscali come sopra descritto, con le autorità fiscali competenti dei paesi o delle giurisdizioni.',
        // prettier-ignore
        report_changes:
            'Accetto/accettiamo di notificare a VV entro 30 giorni qualsiasi cambiamento che influisca sull\'autocertificazione e sulle informazioni fornite, e di fornire a VV una corrispondente autocertificazione aggiornata senza indugio e senza richiesta. Su richiesta, ho/abbiamo accesso ai dati che mi/ci riguardano, che saranno condivisi con le autorità fiscali lussemburghesi, e posso/possiamo correggere i dati personali. I dati raccolti non saranno conservati più a lungo di quanto necessario ai fini della legge lussemburghese sui CRS.',
        complete_and_correct_information:
            'Dichiaro/iamo che tutte le informazioni da me/noi fornite sono corrette e complete al meglio delle mie conoscenze e convinzioni.',
    },
    experience_and_knowledge: {
        experience: 'Esperienza di investimento',
        knowledge: 'Conoscenza di',
        stocks_equity_funds: 'Azioni, fondi azionari',
        mixed_funds_etfs: 'Fondi misti, ETF',
        bonds_bond_funds: 'Obbligazioni, fondi obbligazionari',
        closed_ended_funds: 'Fondi chiusi',
        options_other_derivatives: 'Opzioni, altri derivati',
        venture_capital: 'Venture Capital',
        other_shares_loans_in_private_companies: 'Altre azioni/prestiti di società private',
        other_alternative_investments: 'Altri investimenti alternativi (hedge fund, fondi di materie prime, ecc.)',
        follow_market_prices_business_financial_news:
            'Con quale frequenza controlla i prezzi di mercato, le notizie economiche e finanziarie?',
    },
    follow_market_options: {
        regularly: 'regolarmente',
        occasionally: 'qualche volta',
        rarely: 'raramente',
        not_at_all: 'per niente',
    },
    investment_knowledge: {
        advanced: 'Avanzato',
        basic: 'Di base',
        none: 'Nessuno',
    },
    investment_horizon: {
        short_term: 'A breve termine (< 5 anni)',
        medium_term: 'A medio termine (5-10 anni)',
        long_term: 'A lungo termine (11-20 anni)',
        very_long_term: 'Molto lungo (> 20 anni)',
    },
    investment_frequency: {
        one_off: 'Una tantum',
        monthly: 'Mensile',
        quarterly: 'Trimestrale',
        semi_annually: 'Semestrale',
        annually: 'Annuale',
    },
    risk_tolerance: {
        label: 'La vostra propensione al rischio è:',
        // prettier-ignore
        label_legal: 'Propensione al rischio dell\'investitore (forma giuridica):',
        low: 'Bassa',
        medium: 'Media',
        advanced: 'Avanzata',
        high: 'Alta',
    },
    ecsp: {
        natural: {
            info_text: '',
            info_text_highlight_one: '',
            info_text_highlight_two: '',
            info_text_highlight_three: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            experience: {
                no_answer: '',
                financial_education: '',
                bonds_knowledge: '',
                bonds_investment_frequency: '',
                stocks_knowledge: '',
                stocks_investment_frequency: '',
                convertible_bonds_knowledge: '',
                convertible_bonds_investment_frequency: '',
            },
            risk: {
                no_answer: '',
                startup_investing: '',
                investments_outside_stock_market: '',
                subordinated_financial_instruments: '',
                profit_participation_certificate: '',
            },
        },
        legal: {
            info_text: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            risk: {
                most_startups: '',
                dividends: '',
                higher_interest_rates: '',
                secure_investment: '',
                stocks_bankrupt_company: '',
                good_long_term_investment: '',
                return_on_investment: '',
            },
        },
        investment_frequency: {
            less_than_5_times: '',
            more_than_5_times: '',
            no_answer: '',
        },
        investment_horizon: {
            two_years: '',
            up_to_5_years: '',
            more_than_5_years: '',
            no_answer: '',
        },
        startup_investing: {
            high_return_low_risk: '',
            loss: '',
            growth: '',
        },
        investments_outside_stock_market: {
            low_risk: '',
            high_risk: '',
            high_proportion: '',
        },
        subordinated_financial_instruments: {
            insolvency_quote: '',
            equal_with_other_creditors: '',
            lose_investment: '',
        },
        profit_participation_certificate: {
            participate_profits_losses: '',
            fixed_interest_amount: '',
            transfer_to_company: '',
        },
        investor_classification: {
            expert_investor_treatment: '',
            self_disclosure_explanation: '',
            self_disclosure: '',
            print: '',
            upload_self_disclosure: '',
        },
        financial_education: {
            professional_experience: '',
            relevant_degree: '',
            both: '',
            none: '',
        },
        investment_goals: {
            no_answer: '',
            sustainability: '',
            investment_goal: '',
            investment_horizon: '',
        },
        sustainability: {
            very_true: '',
            applies: '',
            does_not_apply: '',
            no_answer: '',
        },
        investment_goal: {
            wealth_building: '',
            speculative_investments: '',
            no_answer: '',
        },
        most_startups: {
            successful: '',
            fail: '',
        },
        dividends: {
            equity: '',
            debt_capital: '',
        },
        higher_interest_rates: {
            secure_investment: '',
            risk_investment: '',
        },
        secure_investment: {
            bond_brd: '',
            bond_us_treasury: '',
            vw_share: '',
        },
        stocks_bankrupt_company: {
            refund: '',
            loss: '',
        },
        good_long_term_investment: {
            company_investment_portfolio: '',
            scatter_investments: '',
        },
        return_on_investment: {
            less_than_5_years: '',
            more_than_5_years: '',
        },
        financial_situation: {
            calculate: '',
            no_value: 'N/D',
            net_worth: '',
            net_worth_tooltip: '',
            loss_bearing_capacity: '',
            loss_bearing_capacity_tooltip: '',
            annual_net_income: '',
            annual_net_income_tooltip: '',
            annual_financial_commitments: '',
            annual_financial_commitments_tooltip: '',
            calculation_of_net_worth: '',
            liquid_funds: '',
            liquid_funds_tooltip: '',
            info_text: '',
        },
    },
    legal_account: {
        company_profile: '',
        company_name: '',
        registration_number: '',
        legal_form: 'Forma giuridica',
        registration_authority: 'Autorità di registrazione',
        address: '',
        description: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
        iban: '',
        bic: '',
        tax_number: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        investor_classification: '',
        risk: '',
        financial_situation: '',
        default_language: 'Lingua predefinita',
    },
    beneficial_owner: {
        country_of_birth: '',
        city_of_birth: '',
        country_of_residence: '',
        no_beneficial_owners: '',
        no_beneficial_owners_description: '',
        indirect_ownership: 'Inserire il nome della rispettiva società in caso di proprietari indiretti.',
        remove: 'Rimuovere',
    },
    highest_educational_attainment: {
        prefer_not_to_say: '',
        no_degree: '',
        secondary_school: '',
        junior_high_school: '',
        high_school_diploma: '',
        university: '',
    },
    investment_experience: {
        none: '',
        up_to_3_years: '',
        between_3_and_5_years: '',
        more_than_5_years: '',
    },
    average_investment_transaction: {
        none: '',
        up_to_5: '',
        between_5_and_10: '',
        over_10: '',
    },
    average_investment_amount: {
        up_to_3000_eur: '',
        between_3001_and_5000_eur: '',
        between_5001_and_10000_eur: '',
        over_10000_eur: '',
    },
    validation_error: {
        required: '',
        email: '',
        invalid: '',
        countryISO3166: '',
        iban: '',
        bic: '',
        new_email_not_equals_old: '',
        wrong_date_format: '',
        date_min: '',
        date_max: '',
        min_age: '',
        max_age: '',
        min_amount: '',
        min_amount_on_wallet: '',
        max_amount: '',
        duplicate_iban: 'Questo IBAN è già registrato per uno dei tuoi conti bancari.',
    },
    account_settings: {
        dashboard: '',
        personal_data: '',
        personal_data_headline: '',
        address_data: '',
        address_data_headline: '',
        address_data_subtitle: '',
        membership_management: 'Area membri',
        nyala_vault: '',
        nyala_vault_headline: '',
        nyala_vault_subtitle: '',
        postal_address_data: 'Il vostro indirizzo postale',
        compliance_profile: '',
        compliance_profile_subtitle: '',
        contact_data: '',
        contact_data_headline: '',
        contact_data_subtitle: '',
        security: '',
        security_headline: '',
        security_subtitle: '',
        verification: '',
        verification_headline: '',
        verification_subtitle: '',
        bank_data: '',
        bank_data_headline: '',
        bank_data_subtitle: '',
        tax_residencies: 'Residenza fiscale',
        tax_data: '',
        overview: '',
        profile_data: '',
        legal_information: '',
        edit: '',
        legal_information_subtitle: '',
        current_status: '',
        crypto_wallet: '',
        crypto_wallet_headline: '',
        signatures: '',
        signatures_headline: '',
        signatures_subtitle: '',
        referral_program: '',
        referral_program_headline: '',
        referral_program_notice: '',
        // prettier-ignore
        investment_targets: 'Profilo dell\'investitore',
        // prettier-ignore
        investment_targets_subtitle:
            'L\'orizzonte d\'investimento rappresenta la vostra disponibilità di base ad avere un termine d\'investimento. ',
        financial_conditions: 'Posizione finanziaria',
        experience_and_knowledge: 'Esperienza e conoscenza degli investimenti',
        risk_tolerance: 'Propensione al rischio',
        fatca_declaration: 'Dichiarazione FATCA',
        acknowledgements: 'Conferme',
        kyc_form: 'Modulo KYC',
        tax_situation: 'Situazione fiscale',
        investor_classification: '',
        experience: '',
        risk: '',
        investment_goals: '',
        financial_situation: '',
    },
    compliance_profile: {
        save_header: '',
        save_description: '',
        discard_header: '',
        discard_description: '',
        save_financial_data_header: '',
        save_financial_data_description: '',
        back_to_compliance_profile: '',
        status: 'Stato: {status}',
        compliance_profile_complete_and_valid_description: 'Il profilo di conformità è completo e valido.',
        compliance_profile_complete_and_invalid_description: 'Il profilo di conformità è completo ma non valido.',
        compliance_profile_incomplete_description: 'Il profilo di conformità è incompleto.',
        complete: 'Completo',
        incomplete: 'Incompleto',
        complete_data: 'Profilo di conformità completo',
        complete_data_description: 'Completare i dati del profilo di conformità per continuare.',
        show_document: 'Mostra documento',
        upload_document: 'Carica un nuovo documento',
        edit_data: '',
        discard_data: '',
    },
    signatures: {
        complete_data_description_for_signatures: '',
        complete_compliance_profile: 'Profilo di conformità completo',
        sign_document: '',
        sign_documents: '',
        not_signed: '',
        signed: '',
        no_signatures: '',
        no_signatures_description: '',
        pending_signatures: '',
        pending_signatures_description: '',
        show_document: '',
        dialog_close_button: '',
        regenerate_signatures: '',
        regenerate_signatures_notice: '',
        print: '',
    },
    account_settings_legal: {
        dashboard: '',
        company_data: '',
        overview: '',
        address_data: '',
        bank_data: '',
        tax_data: '',
        verification: '',
        verification_kyc_documents_subtitle: '',
        manager_area: '',
        manager_area_subtitle: '',
        beneficial_owners: '',
        beneficial_owners_subtitle: '',
        // prettier-ignore
        investment_objectives: 'Profilo di investimento dell\'azienda',
        financial_conditions: 'Posizione finanziaria della società',
        // prettier-ignore
        risk_tolerance: 'Propensione al rischio dell\'azienda',
        tax_situation: 'Informazioni fiscali',
        crs_classification: 'Classificazione CRS',
        acknowledgements: 'Conferme',
    },
    legal_account_manager_beneficial_owner: {
        beneficial_owner: 'Proprietario effettivo',
        manager: 'Responsabile',
        postal_address: 'Indirizzo postale',
        no_beneficial_owners: 'Non sono stati aggiunti altri aventi diritto economico',
    },
    legal_account_beneficial_owners: {
        add_beneficial_owner: '',
        manager: '',
    },
    legal_account_managers: {
        beneficial_owner: '',
        add_manager: '',
        manager_invited_notice: '',
        pending_invitations: '',
        dialogs: {
            failure_title: '',
            failure_message: '',
            failure_button: '',
            success_title: '',
            success_message: '',
            success_button: '',
            registration_required_title: '',
            registration_required_message: '',
            registration_required_button: '',
            already_accepted_title: '',
            already_accepted_message: '',
            already_accepted_button: '',
            legal_account_already_exists_title: '',
            legal_account_already_exists_message: '',
            legal_account_already_exists_button: '',
        },
    },
    account_links: {
        heading: '',
        orders: '',
        wallet: '',
        secondary_market: 'Mercato secondario',
    },
    referral_program: {
        your_referral_link: '',
        your_referral_code: '',
        generate_referral_code: '',
        generate_referral_code_description: '',
        generated_referral_code_successfully_message: '',
        generated_referral_code_error_message: '',
        referral_link_social_media_sharing: '',
        referral_info_title: '',
        referral_info_message: '',
        referral_existing_user_title: '',
        referral_existing_user_message: '',
        referral_campaign_not_found_title: '',
        referral_campaign_not_found_message: '',
        referral_success_custom_event_title: '',
        referral_success_custom_event_message: '',
        referral_success_redemption_event_title: '',
        referral_success_redemption_event_message: '',
    },
    verification: {
        pdf_both_sides: 'PDF (con entrambi i lati)',
        upload_id_pdf: 'Clicca qui per caricare il file (PDF)',
        upload_id_image: 'Clicca qui per caricare il file (JPG, PNG, JPEG)',
        identity_verification: '',
        identity_verification_subheadline: '',
        identity_verification_upload_notice: '',
        tax_verification: '',
        bank_verification: '',
        bank_verification_headline: '',
        address_verification: '',
        address_verification_headline: '',
        address_verification_subheadline: '',
        legal_verification: '',
        legal_verification_subheadline: '',
        legal_bank_verification: '',
        legal_bank_verification_subheadline: '',
        upload_label: '',
        upload_invalid_field: '',
        upload_waiting_for_size: '',
        upload_size_not_available: '',
        upload_loading: '',
        upload_load_error: '',
        upload_processing: '',
        upload_processing_complete: '',
        upload_processing_aborted: '',
        upload_processing_error: '',
        upload_processing_revert_error: '',
        upload_file_remove_error: '',
        upload_tap_to_cancel: '',
        upload_tap_to_retry: '',
        upload_tap_to_undo: '',
        upload_button_remove_item: '',
        upload_button_abort_item_load: '',
        upload_button_retry_item_load: '',
        upload_button_abort_item_processing: '',
        upload_button_undo_item_processing: '',
        upload_button_retry_item_processing: '',
        upload_button_process_item: '',
        tax_verification_headline: '',
        complete_data: '',
        complete_data_description: '',
        complete_data_description_for_verification: '',
        complete_data_description_short: '',
        complete_verification_outstanding: '',
        complete_verification_complete: '',
        completed_data: '',
        completed_data_description: '',
        complete_data_action_button: '',
        kyc_process: '',
        kyc_process_description: '',
        kyc_process_action_button: '',
        old_value: '',
        no_changes: 'Tutti i dati sono uguali a quelli inseriti in precedenza.',
        save: 'Salva',
        depot: 'Conto titoli',
        depot_verification_subheadline:
            'Si prega di fornire qui le informazioni necessarie relative al suo conto titoli.',
        new_value: '',
        override_data: '',
        override_data_description: '',
        verification_successful: '',
        verification_successful_description: '',
        status_not_started: '',
        status_not_started_description: '',
        status_created: '',
        status_created_description: '',
        status_in_review: '',
        status_in_review_description: '',
        status_data_changed: '',
        status_data_changed_description: '',
        status_success: '',
        status_success_description: '',
        status_failure: '',
        // prettier-ignore
        status_user_canceled: 'Annullato dall\'utente',
        status_user_canceled_loading_description: 'Il caricamento ha impiegato troppo tempo',
        status_user_canceled_unavailable_description: 'Non ho i documenti / le informazioni necessarie',
        status_user_canceled_privacy_description: 'Ho preoccupazioni sulla privacy',
        status_user_canceled_unclear_description: 'Non sono sicuro di cosa devo fare',
        status_user_canceled_technical_description: 'Problemi tecnici',
        status_user_canceled_other_description: 'Nessuno dei suddetti',
        status_user_canceled_unknown_description: 'Motivo sconosciuto',
        status_failure_description: '',
        id_now_kyc_continue_button: '',
        id_now_kyc_waiting_for_id_now_button: '',
        id_now_kyc_restart_button: '',
        id_now_kyc_start_button: '',
        ecsp_status_rejected: 'Non conoscibile - rifiutato',
        ecsp_status_pending: 'Non autorizzato - verifica in corso',
        ecsp_status_expert: 'Conoscibile',
        ecsp_status_non_expert: 'Non informato',
        signteq_kyc_start_button: 'Avviare la verifica KYC',
        signteq_kyc_restart_button: 'Ricomincia il processo KYC',
    },
    verification_kyc_document: {
        show_details_button: '',
        hide_details_button: '',
        uploaded_at: '',
        comment: '',
        valid_to: '',
        verified_at: '',
        add_new_document: '',
        identification_type: '',
        in_progress: '',
        in_progress_description: '',
        on_hold: '',
        on_hold_description: '',
        accepted: '',
        accepted_description: '',
        accepted_not_eligible_for_withdrawal_description: '',
        accepted_not_eligible_for_withdrawal_description_re_upload: '',
        accepted_not_eligible_for_withdrawal_description_contact_support: '',
        rejected: '',
        rejected_description: '',
        unreadable: '',
        unreadable_description: '',
        expired: '',
        expired_description: '',
        wrong_type: '',
        wrong_type_description: '',
        wrong_name: '',
        wrong_name_description: '',
        duplicate_document: '',
        duplicate_document_description: '',
        type: {
            'passport': '',
            'invoice': '',
            'id-card': '',
            'residence-confirmation': '',
            'bank-statement': '',
            'sdd-mandate': '',
            'company-registration': '',
            'articles-of-association': '',
            'other': '',
        },
    },
    crypto_wallet: {
        request_wallet_button: '',
        notice: '',
        complete_verification_description_for_crypto_wallet: '',
        complete_data_description_for_crypto_wallet: '',
        success_dialog_title: '',
        success_dialog_description: '',
        success_dialog_button: '',
        error_dialog_title: '',
        error_dialog_description: '',
        error_dialog_button: '',
    },
    nyala_vault: {
        pin_info: '',
        reset_pin: '',
        invalid_pin: '',
        enter_a_valid_pin: '',
        reset_initiated_info: '',
        generate_random_pin: '',
        invalid_nyala_pin: '',
        nyala_new_pin: '',
        nyala_confirm_pin: '',
        explorer: '',
        explorer_link: '',
        confirm_pin: '',
        enter_confirm_pin: '',
        pin_confirmed: '',
        nyala_vault_not_created: '',
        vault_not_created_yet_at_nyala: '',
        nyala_passphrase_verification_success_title: '',
        nyala_passphrase_verification_success_message: '',
        nyala_passphrase_verification_expired_link_title: '',
        nyala_passphrase_verification_expired_link_message: '',
        invalid_link: 'Il link non è più valido!',
    },
    bank_data: {
        iban_from_bank_account_notice: '',
        iban_from_bank_account_link_button: '',
        set_bank_data_from_profile: '',
    },
    bank_account: {
        bank_accounts: 'Conti bancari',
        holder: 'Titolare del conto',
        iban: 'IBAN',
        status: 'Stato',
        is_main: 'Conto principale',
        empty_state_header: 'Nessun conto bancario',
        empty_state_description: 'Aggiungi un conto bancario per ricevere i pagamenti.',
        main_bank_account: 'Conto principale',
        set_as_main_bank_account: 'Imposta come principale',
        set_as_main_bank_account_success_message: 'Il conto bancario è stato impostato come principale.',
        in_progress: 'In corso',
        accepted: 'Accettato',
        rejected: 'Rifiutato',
        expired: 'Scaduto',
        bic: 'BIC',
        add_bank_account: 'Aggiungi conto bancario',
        primary_bank_account: 'Conto bancario principale',
        delete_confirm_title: 'Eliminare il conto bancario?',
        delete_confirm_message:
            'Sei sicuro di voler eliminare questo conto bancario? Questa azione non può essere annullata.',
        delete_success_message: 'Conto bancario eliminato con successo.',
        update_success_message: 'Conto bancario aggiornato con successo.',
        create_success_message: 'Conto bancario aggiunto con successo.',
    },
    membership_document: {
        status: {
            accepted: 'Accettato',
            pending: 'In attesa',
            rejected: 'Rifiutato',
        },
    },
    wallet: {
        vouchers: 'Buoni',
        my_wallets: 'I miei portafogli',
        my_wallets_subtitle: 'Panoramica dei miei portafogli',
        my_wallets_lemonway_note:
            'Attualmente potrebbero esserci limitazioni sui prelievi dal vostro portafoglio. Stiamo già lavorando intensamente a una soluzione e vi terremo aggiornati.',
        deposit: 'Deposito',
        withdraw: 'Prelievo',
        secupay: 'Secupay',
        last_balance: 'Ultimo saldo al 31.03.2026',
        secupay_amount_info_text: 'Solo provider di pagamento, \n Nessun saldo da mostrare',
        lemonway: 'Lemonway',
        type: 'Tipo di portafoglio',
        no_transactions: 'Nessuna transazione trovata',
        account_holder: '',
        payment_reference: '',
        payment_amount: '',
        accept_terms: '',
        accept_terms_link: '',
        my_wallet: '',
        my_wallet_subtitle: '',
        legal_wallet: '',
        legal_wallet_subtitle: '',
        no_wallet: '',
        no_wallet_description: '',
        current_balance: '',
        retrievable_balance: '',
        voucher_balance: '',
        withdrawal_button: '',
        withdrawal_header: '',
        withdrawal_description: '',
        verify_bank_account_alert_header: '',
        verify_bank_account_alert_description: '',
        verify_bank_account_alert_action_button: '',
        verify_wallet_alert_header: '',
        verify_wallet_alert_description: '',
        verify_wallet_alert_action_button: '',
        deposit_header: '',
        deposit_via_bank_transfer_header: '',
        deposit_via_bank_transfer_description: '',
        deposit_button: '',
        deposit_description: '',
        withdrawal_button_submit: '',
        deposit_button_submit: '',
        transaction_history: '',
        transaction_history_subtitle: '',
        transaction_history_export_button: '',
        transaction_date: '',
        transaction_title: '',
        transaction_payment_method: '',
        transaction_amount: '',
        edit_profile: '',
        withdrawal_pending_heading: '',
        withdrawal_amount: '',
        withdrawal_account_description: '',
        deposit_amount: '',
        confirm_withdrawal_title: '',
        confirm_withdrawal_description: '',
        cancel_wallet_withdrawal_confirm_heading: '',
        cancel_wallet_withdrawal_confirm_description: '',
        cancel_wallet_withdrawal: '',
        cancel_wallet_withdrawal_success: '',
        cancel_wallet_withdrawal_error: '',
        withdrawal_bank_account: '',
        withdrawal_bank_account_select: '',
        payment_options: {
            bank_transfer: '',
            credit_card: '',
        },
        lw_trasaction_type: {
            0: '',
            1: '',
            2: '',
        },
        lw_trasaction_method: {
            0: '',
            1: '',
            4: '',
            3: '',
            13: '',
            14: '',
            15: '',
            16: '',
            17: '',
            18: '',
            19: '',
            20: '',
            21: '',
            22: '',
            23: '',
            24: '',
            25: '',
            26: '',
            27: '',
            28: '',
            29: '',
        },
        dialogs: {
            money_withdrawal_verification_expired_link_title: '',
            money_withdrawal_verification_expired_link_message: '',
            money_withdrawal_verification_withdrawal_expired_title: 'Prelievo scaduto',
            money_withdrawal_verification_withdrawal_expired_message:
                'Il prelievo è scaduto. Si prega di avviare una nuova richiesta di prelievo.',
            money_withdrawal_verification_no_longer_pending_title: '',
            money_withdrawal_verification_no_longer_pending_message: '',
            money_withdrawal_verification_success_title: '',
            money_withdrawal_verification_success_message: '',
            money_deposit_successful_title: '',
            money_deposit_successful_description: '',
            money_deposit_canceled_title: '',
            money_deposit_canceled_description: '',
            money_deposit_error_title: '',
            money_deposit_error_description: '',
            success_button: '',
            failure_button: '',
        },
    },
    voucher: {
        balance: '',
    },
    table: {
        pagination_results_overview: '',
        next: '',
        previous: '',
    },
    pending_investment_process: {
        title: '',
        description: '',
        resume_button: '',
        cancel_button: '',
    },
    texts: {
        email_change_notice: '',
        required: '',
        required2: '',
    },
    widget: {
        save: 'Salva + Continua',
        back: 'Torna a',
        sign_up_as: 'Sono una',
        natural_person: 'Persona fisica',
        legal_entity: 'Forma giuridica',
        step_counter: 'Passo {currentStep} di {totalSteps}',
        close: 'Annullamento',
    },
    esac_widget_sidebar: {
        // prettier-ignore
        natural_legal_select:
            '<p>Benvenuti alla procedura guidata KYC per la piattaforma di investimento European Super Angels Club. Una volta completato il processo di KYC (compreso il caricamento dei documenti richiesti e l\'approvazione da parte di Venionaire Ventures), avrete accesso a tutti gli investimenti su questa piattaforma e potrete investire in varie opportunità.</p> <p>Se avete bisogno di un\'assistenza tecnica, potete farlo.' +
            '<p>Se avete domande sul processo di KYC o avete bisogno di assistenza, contattate il nostro team di supporto all\'indirizzo <a href="mailto:platform@superangels.club">platform@superangels.club</a>.</p>' +
            '<p>Questa procedura richiede circa 5 minuti per le persone fisiche e 10-15 minuti per le persone giuridiche.' +
            '<p>Avrete bisogno delle seguenti informazioni:</p>' +
            '<p><strong>Persona fisica:</strong><br>' +
            '<ul><li>Informazioni fiscali</li></ul></p>' +
            '<p><strong>Persona giuridica:</strong><br>' +
            '<ul><li>Informazioni fiscali</li>' +
            '<li>Classificazione CRS e FATCA</li>' +
            '<li>Informazioni sull\'esperienza di investimento del secondo firmatario autorizzato (se applicabile)</li></ul></p>',
        natural_personal_data: 'Si prega di inserire i propri dati personali.',
        // prettier-ignore
        natural_address_data:
            'Inserire l\'indirizzo di residenza e l\'indirizzo postale (se diverso). L\'indirizzo di residenza deve corrispondere alla conferma dell\'indirizzo che caricherete successivamente nel processo KYC.',
        // prettier-ignore
        natural_investment_targets:
            'Per l\'investitore è importante conoscere il suo atteggiamento generale nei confronti del tipo di investimento, la sua propensione al rischio, la sua tolleranza al rischio e le sue conoscenze. Vi chiediamo pertanto di compilare questo modulo in modo veritiero.',
        financial_conditions:
            'La preghiamo di completare le informazioni sulla sua situazione finanziaria. Abbiamo bisogno di capire la sua propensione al rischio in relazione al suo patrimonio netto approssimativo.',
        // prettier-ignore
        natural_experience_and_knowledge:
            'Confermare la conoscenza e l\'esperienza pratica di investimento negli strumenti elencati.',
        natural_fatca: 'Confermare il proprio status FATCA.',
        natural_tax: 'Confermare la propria posizione fiscale e i paesi in cui si è residenti fiscalmente.',
        acknowledgements:
            'Leggere attentamente e confermare le dichiarazioni fornite. Queste saranno firmate elettronicamente sui moduli KYC.',
        // prettier-ignore
        natural_kyc_form:
            'Congratulazioni, avete completato con successo l\'Assistente KYC!' +
            ' Questo modulo "Questionario per gli investitori" contiene tutte le informazioni e le conferme che avete appena fornito. La preghiamo di leggere attentamente il modulo e di firmarlo elettronicamente. \n' +
            'È inoltre necessario caricare i documenti che provano la sua identità.\n' +
            'Il modulo e la documentazione saranno esaminati da Venionaire Ventures e, una volta approvati, riceverete una notifica e potrete accedere a tutte le opportunità di investimento su questa piattaforma. Vi contatteremo per qualsiasi domanda.<br>< br>' +
            'Se la firma elettronica non è possibile, si prega di stampare il contratto cartaceo, firmarlo e inviarlo a:<br>< br>' +
            'Venionaire Capital AG<br>' +
            'Babenbergerstraße 9/12<br>' +
            'A-1010 Vienna, Austria (UE)',
        // prettier-ignore
        legal_company_information:
            'Si prega di fornire i dati di registrazione della società investitrice (di seguito "Investitore" o "Entità"). \n' +
            'Si prega di notare che in questo assistente gli Amministratori Delegati ("MD") sono definiti come i firmatari autorizzati dell\'Investitore; gli Ultimate Beneficial Owners ("UBO") possiedono o controllano una partecipazione nell\'Investitore (persona giuridica). \n' +
            'Si prega di aggiungere tutti gli UBO che possiedono il 20% o più del capitale sociale e/o dei diritti di voto e tutti gli MD necessari per essere firmatari autorizzati dell\'investitore e per decidere su un potenziale investimento.',
        // prettier-ignore
        legal_address_information: 'Inserire l\'indirizzo legale della società investitrice.',
        legal_manager_one_personal: 'Inserire i propri dati personali e selezionare il tipo di controllo.',
        legal_manager_two_personal:
            'Inserire i dati personali del rispettivo MD o UBO e selezionare il tipo di controllo.',
        legal_managers_ubo_overview:
            'Si prega di aggiungere un potenziale co-amministratore delegato (rappresentanza congiunta della persona giuridica che investe) e altri beneficiari effettivi (proprietà > 20%) della persona giuridica che investe (se applicabile).',
        legal_manager_one_address: 'Inserire il proprio indirizzo.',
        // prettier-ignore
        legal_manager_two_address: 'Inserire l\'indirizzo di residenza del rispettivo MD o UBO.',
        legal_manager_one_tax: 'Inserire i dati fiscali e di proprietà',
        legal_manager_two_tax: 'Inserire i dati fiscali e di proprietà del rispettivo MD o UBO.',
        // prettier-ignore
        legal_entity_investment_profile:
            'È importante conoscere l\'atteggiamento generale dell\'investitore nei confronti del tipo di investimento, la sua propensione al rischio, la sua tolleranza al rischio e le sue conoscenze. Vi chiediamo pertanto di compilare questa sezione per l\'investitore in modo veritiero.',
        legal_entity_financial_position:
            'La preghiamo di compilare queste informazioni sulla situazione finanziaria della società. Questo per capire la propensione al rischio della Società in relazione alle sue attività finanziarie nette approssimative.',
        // prettier-ignore
        legal_manager_one_experience_and_knowledge:
            'Si prega di indicare la propria esperienza e conoscenza personale nelle classi di attività e nei mercati finanziari indicati. Si prega di compilare questo modulo personalmente come MD (e non per l\'entità giuridica che investe).',
        // prettier-ignore
        legal_manager_two_experience_and_knowledge:
            'Indicare l\'esperienza e le conoscenze personali di MD 2 nelle classi di attività e nei mercati finanziari indicati.',
        // prettier-ignore
        legal_manager_two_authorization:
            'Si prega di completare l\'esperienza e le conoscenze in materia di investimenti dell\'MD 2 con la sua autorizzazione. Questo sarà incluso in un modulo KYC firmato da entrambi i gestori.',
        legal_entity_fatca:
            'Le informazioni contenute in questa sezione sono da considerarsi ai fini FATCA. Si prega di notare che questa classificazione può differire dalla classificazione CRS.',
        legal_entity_tax_situation:
            'Confermare la posizione fiscale della società e i Paesi in cui è residente fiscalmente.',
        legal_entity_crs: 'Selezionare la classificazione CRS della società:',
        legal_acknowledgements:
            'Leggere attentamente e confermare le dichiarazioni fornite. Queste saranno firmate elettronicamente sui moduli KYC.',
        legal_beneficial_owner: 'Completare i dati personali del beneficiario effettivo.',
        legal_kyc_form:
            'Grazie per aver completato la procedura guidata KYC! Il modulo "ESAC Legal Entity" contiene tutte le informazioni e le conferme appena fornite. Leggete attentamente il modulo e firmatelo elettronicamente. Se avete un secondo firmatario autorizzato (MD 2), anche lui deve firmare questo modulo. I documenti parzialmente preparati ("ESAC Legal UBO for ...") devono essere compilati e firmati dai rispettivi beneficiari effettivi. I documenti completamente compilati e firmati devono essere caricati sulla pagina del Conto aziendale della piattaforma (selezionare il proprio profilo in alto a destra, quindi Conto aziendale e Firme in basso a sinistra). \n' +
            'I moduli e i documenti saranno esaminati da Venionaire Ventures e, una volta approvati, riceverete una notifica e potrete accedere a tutte le opportunità di investimento su questa piattaforma. Vi contatteremo per qualsiasi domanda.',
    },
    security: {
        password: {
            title: '',
            hint: '',
            update: '',
        },
        two_factor_authentication: {
            title: '',
            hint: '',
            configure: '',
            list_title: '',
            type: '',
            types: {
                otp: '',
                sms: '',
                passkey: '',
            },
            user_label: '',
            date: '',
            action: '',
            remove: '',
            non_removeable: '',
            remove_success: '',
        },
        dialogs: {
            error_title: '',
            error_message: '',
            success_title: '',
            success_message: '',
        },
        external_security_link: {
            title: '',
            hint: '',
            redirect: '',
        },
    },
    dialog: {
        button: {
            confirm: '',
            cancel: '',
            back: '',
            close: '',
            ok: '',
        },
        formDirty: {
            title: '',
            text: '',
            confirm: '',
            cancel: '',
        },
        formInvalid: {
            title: '',
            text: '',
        },
        iframe_link_notice: '',
        iframe_link_notice_link: '',
    },
    yes_no_deny: {
        yes: '',
        no: '',
        no_answer: '',
    },
    camera: {
        click_here_to_capture_image: 'Fare clic qui per scattare una foto',
        close: 'Chiudere la fotocamera',
        or: 'o',
    },
    id_front: 'Anteriore',
    id_back: 'Indietro',
    // prettier-ignore
    newsletter_verification_success: 'L\'iscrizione alla newsletter via e-mail è stata confermata con successo!',
}
